import React from "react";
import {
    Dialog,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    Button,
    DialogActions,
    IconButton,
    DialogTitleProps,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

function BootstrapDialogTitle(props: any) {
    const { children, onClose, ...other }: any = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme: any) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
}

const GeneralInfoModal = ({
    maxWidth,
    title,
    subtitle,
    children,
    isOpen,
    handleClose,
    handleConfirm,
}: any) => {
    return (
        <Dialog maxWidth={maxWidth || "md"} open={isOpen} onClose={handleClose}>
            <BootstrapDialogTitle
                id="customized-dialog-title"
                onClose={handleClose}
            >
                {title}
            </BootstrapDialogTitle>
            <DialogContent>
                {/* <Divider /> */}
                {children}
            </DialogContent>
        </Dialog>
    );
};

export default GeneralInfoModal;
